<template>
  <SportPage />
</template>
<script setup lang="ts">
useSeoData('sport-category')
</script>
